import React from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { compose } from '@beef/redux';
import PropTypes from 'prop-types';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../../../utils";
import { LottiePlayer } from "../../../LottiePlayer";
import styles from "./styles.pcss";
import { StepsSlideContext } from "../../context";
var cx = classNames.bind(styles);
var _SlideContent = function _SlideContent(_ref) {
  var description = _ref.description,
    title = _ref.title,
    imageUrl = _ref.imageUrl,
    lottieLink = _ref.lottieLink,
    _ref$lottieLoop = _ref.lottieLoop,
    lottieLoop = _ref$lottieLoop === void 0 ? false : _ref$lottieLoop;
  var _React$useContext = React.useContext(StepsSlideContext),
    isActive = _React$useContext.isActive;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('slide', {
      'slide-active': isActive
    }),
    "data-t-id": "slides-SlideContent"
  }, /*#__PURE__*/React.createElement("article", {
    className: cx('card', {
      'card-active': isActive
    })
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx('title')
  }, title), imageUrl && /*#__PURE__*/React.createElement("img", {
    alt: title,
    className: cx('image'),
    src: imageUrl
  }), lottieLink && /*#__PURE__*/React.createElement("div", {
    className: cx('animation')
  }, /*#__PURE__*/React.createElement(LottiePlayer, {
    animationLink: lottieLink,
    autoplay: true,
    loop: lottieLoop
  })), /*#__PURE__*/React.createElement(Text, {
    className: cx('text')
  }, description)));
};
export var SlideContent = compose(enhancedConnect({
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  lottieLink: PropTypes.string,
  title: PropTypes.string,
  lottieLoop: PropTypes.bool
}), withAutoMetric.Item(function () {
  return {
    name: 'SlideContent'
  };
}))(_SlideContent);